<template>
  <div class="wrapper">
  </div>
</template>

<script>
  export default {
    name: 'sy_le_deeplink',
    data () {
      return {
      }
    },
    methods: {
      checkUa () {
        const ua = window.navigator.userAgent
        const wechat = ua.match(/MicroMessenger/)
        const ios = ua.match(/iPhone|iPad|iPod|iOS|Mac OS X/)

        if (ios) {
          return 'ios'
        } else if (wechat) {
          return 'wechat'
        } else {
          return 'android'
        }
      },
      openRoom (roomid) {
        // 如果是SDK版分享
        const type = this.checkUa()
        const url = `letvclient://msiteAction?actionType=30&pid=${roomid}&version=2.0`

        if (type === 'ios') {
        window.location.href = url
        } else if (type === 'wechat') {
        this.$notify('请在系统浏览器中打开')
        } else {
        //this.link = url
        this.schemeHREF(url);
        if (!this.timer) {
            this.timer = setTimeout(() => {
            this.timer = null
            window.location.href = url
            }, 2000)
        }
        }
      },
      schemeLocation (url) {
          window.location = url;
      },
      schemeHREF (url) {
          var a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          document.body.appendChild(a);
          a.click();
      },
    },
    created() {
        var type = this.checkUa()
        var env = window.location.host.match(/mp-cdn/) ? 'release' : 'debug'
        var hours = new Date().getHours()
        if (hours<12) { //12点以前跳转到下载页
            if (type === 'ios') {
                window.location.href = window.location.href.replace(/\/sy\/le_deeplink/, '/sy/download?s=220210000')
            } else if (type == 'android') {
                window.location.href = window.location.href.replace(/\/sy\/le_deeplink/, '/sy/download?s=230110016')
            }
        } else if (hours >= 12 && hours < 15) { //12：00-15：00  27300  魔仙堡
            if (env == 'release') {
                this.openRoom(27300);
            } else {
                this.openRoom(10341);
            }
        } else if (hours >= 15 && hours < 18) { //15：00-18：00  29063 初音女神
            if (env == 'release') {
                this.openRoom(29063);
            } else {
                this.openRoom(10313);
            }
        } else if (hours >= 18 && hours < 21) { //18：00-21：00  20291  暗里着迷
            if (env == 'release') {
                this.openRoom(20291);
            } else {
                this.openRoom(10315);
            }
        } else if (hours >= 21) { //21：00-24：00  20087  甜心女神
            if (env == 'release') {
                this.openRoom(20087);
            } else {
                this.openRoom(10123);
            }
        }
    },
  }
</script>

<style>
  html, body, #app{
    height: 100%;
    background-color: #080524;
  }
</style>
